(function (app) {

    app.provider("fileApi",
        [function () {
            this.$get = [
                "crmApiGateway", "baseApiUrl", function (crmApiGateway, baseApiUrl) {
                    var service = {};

                    // GETs
                    service.get = function (fileId) {
                        return crmApiGateway.getFile("/Files/" + fileId);
                    };

                    service.getFileUrl = (fileId) => {
                        return `${baseApiUrl}/Files/${fileId}`;
                    };

                    // PUTs
                    service.updateFile = function (fileId, file) {
                        return crmApiGateway.putFile("/Files/" + fileId, file);
                    };

                    service.updateName = function (fileId, file) {
                        return crmApiGateway.put("/Files/" + fileId + "/FileName", file);
                    };

                    service.updateFileDirectory = function (fileId, file) {
                        return crmApiGateway.put("/Files/" + fileId + "/Directory", file);
                    };

                    // DELETEs
                    service.delete = function (fileId) {
                        return crmApiGateway.delete("/Files/" + fileId);
                    };

                    return service;
                }
            ];
        }
        ]);

})(window.app); //jshint ignore:line